/** @type {import('./$types').LayoutLoad} */
export function load({ params }) {
  const { region } = params

  return { region }
}
